import { Editors } from 'slickgrid';

export function text() {
  return Editors.Text;
}
